import React from 'react';

import Content from '@components/Dashboard/ProductAnalytics/ProductTagOnboarding';

const ProductTagOnboarding: React.FC = () => {
  return <Content />;
};

export default ProductTagOnboarding;
